export const initAiIdExchange = async () => {
	const tcdcmpid =
		new URLSearchParams(window.location.search).get('tcdcmpid') ||
		sessionStorage.getItem('tcdcmpid');
	if (tcdcmpid && window.aiIdExchange) {
		try {
			const { callsourceSessionId } = await window.aiIdExchange(tcdcmpid);
			window.coxAutoDataLayer.push({
				user: {
					sessionizedCallTrackingId: callsourceSessionId
				}
			});
		} catch (e) {
			window?.DDC?.log('error', 'aiIdExchange failed');
		}
	}
};
